import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { mergeMap } from "rxjs/operators";
import { ConfigService } from '../../../../config/config.service';
import { ArticleGenerique } from './article-generique';

@Injectable({
  providedIn: 'root'
})
export class ArticleGeneriqueService {

  constructor(
    private configService: ConfigService,
    private http: HttpClient
  ) { }

  public getArticleGenerique(code: string): Observable<ArticleGenerique> {
    return this.configService.getConfig().pipe(
      mergeMap(config => {
        return this.http.get<ArticleGenerique>(config.apiPoint + config.getArticle.replace("{article}", code));
      })
    );
  }
}
